import { useEffect, useState } from 'react';

export const usePageVisibility = () => {
  const [pageVisibility, setPageVisibility] = useState<
    'visible' | 'hidden' | 'prerender'
  >(document.visibilityState);
  const onVisibilityChange = () => setPageVisibility(document.visibilityState);

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange, false);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  });

  return pageVisibility;
};
